module.exports = __webpack_public_path__ + "88ecfcb88c0a2fbaf723a4abbb8d2b90.pdf";